import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, ChevronRightIcon, PlusIcon, SearchIcon } from 'lucide-react';
import { FoundPetDialog } from '../components/animaux/FoundPetDialog';
import { PetAtna, PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petTodos, pets } from '../data/animaux';
export function MesAnimaux() {
  const [foundOpen, setFoundOpen] = useState(false);
  const todos = pets.flatMap(pet => (petTodos[pet.id] ?? []).map(todo => ({
    ...todo,
    pet
  })));
  return <main className="bg-white" data-id="element-1984" data-mp="20n7l9jzx111h">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1985" data-mp="20ld0c5on98xe">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1986" data-mp="1vnbh9kr7x9lx">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1987" data-mp="2ak2js2w6v1fr">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1988" data-mp="25nc2xdck81ta" />
          <span aria-current="page" data-id="element-1989" data-mp="1jl04ngbqejnv">My pets</span>
        </nav>

        <header className="mt-4" data-id="element-1990" data-mp="1jml0radp2anu">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1991" data-mp="1oiji4e0luser">My pets</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-1992" data-mp="1skn4vysq5jfc">
            Your pets, their licences and what matters — all in one place.
          </p>
        </header>

        <div className="mt-8" data-id="element-1993" data-mp="22jce736k1vjz">
          <PetAtna data-id="element-1994" data-mp="22i1djc8ep3x3" />
        </div>

        <section aria-labelledby="pets-list-title" className="mt-14" data-id="element-1995" data-mp="22h00513x45c7">
          <h2 id="pets-list-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1996" data-mp="27gw450cm7wrr">
            My pets
          </h2>

          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-1997" data-mp="2cb9s4hoy71me">
            {pets.map(pet => <li key={pet.id} className="flex" data-id="element-1998" data-mp="2gclnz4yf0j31">
                <Link to={`/my-pets/${pet.id}`} className="group flex w-full items-center gap-4 rounded-3xl border border-slate-200 bg-white p-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1999" data-mp="2ladebujevx54">
                  <img src={pet.photo} alt={pet.name} className="h-24 w-24 shrink-0 rounded-2xl object-cover" data-id="element-2000" data-mp="l59gs6i61toj" />
                  <div className="min-w-0 flex-1" data-id="element-2001" data-mp="zy1w0wtm72g4">
                    <p className="text-lg font-extrabold text-ville-navy" data-id="element-2002" data-mp="v4h3hkasj0ob">{pet.name}</p>
                    <p className="text-sm text-slate-500" data-id="element-2003" data-mp="18w5flnl1hp5a">
                      {pet.breed} · {pet.age}
                    </p>
                    <p className="mt-2 inline-flex rounded-full bg-ville-indigo-soft px-3 py-1 text-xs font-bold text-ville-indigo" data-id="element-2004" data-mp="14us715qkb7uo">
                      Licence active
                    </p>
                    <p className="mt-2 font-mono text-xs tracking-widest text-slate-500" data-id="element-2005" data-mp="1dwjeaf0r3mqn">{pet.medal}</p>
                    <p className="text-xs text-slate-500" data-id="element-2006" data-mp="3kmzligrbdmqz">Valid until: {pet.validUntil}</p>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2007" data-mp="3fooaw3t7387p">
                      View the card
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2008" data-mp="203nko0uasbyl" />
                    </span>
                  </div>
                </Link>
              </li>)}

            <li className="flex" data-id="element-2009" data-mp="1qd16mb28bti0">
              <button type="button" className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2010" data-mp="1qc9eja7ucdwh">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2011" data-mp="17g020rcl7vel">
                  <PlusIcon className="h-6 w-6" data-id="element-2012" data-mp="2wslftk5ymbwa" />
                </span>
                <span className="text-[15px] font-bold text-ville-navy" data-id="element-2013" data-mp="31t91dqbf60j4">Add a pet</span>
              </button>
            </li>

            <li className="flex" data-id="element-2014" data-mp="11pf510cbplde">
              <button type="button" onClick={() => setFoundOpen(true)} className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2015" data-mp="xpekqz2jmfyf">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2016" data-mp="e15fbnbzodgz">
                  <SearchIcon className="h-6 w-6" data-id="element-2017" data-mp="a0v8k8gdhj12" />
                </span>
                <span data-id="element-2018" data-mp="52bn095oy998">
                  <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2019" data-mp="52tu60tw67vx">Animal found</span>
                  <span className="block text-sm text-slate-500" data-id="element-2020" data-mp="1nz3wcre8j8">Scan its collar or report it</span>
                </span>
              </button>
            </li>
          </ul>
        </section>

        <section aria-labelledby="todo-title" className="mt-14" data-id="element-2021" data-mp="3h3qugj912je9">
          <h2 id="todo-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2022" data-mp="3m33njlqhsmpa">
            To do
          </h2>
          {todos.length === 0 ? <p className="mt-3 flex items-center gap-2 text-sm text-slate-500" data-id="element-2023" data-mp="3r0vgmj2viev2">
              <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-2024" data-mp="3w11be84fwhhd" />
              Everything is up to date.
            </p> : <ul className="mt-5 space-y-3" data-id="element-2025" data-mp="33cc8c3jtq22z">
              {todos.map(todo => <li key={`${todo.pet.id}-${todo.id}`} data-id="element-2026" data-mp="38ci3htpay6pt">
                  <Link to={`/my-pets/${todo.pet.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2027" data-mp="38ax861v5yjqw">
                    <img src={todo.pet.photo} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover" data-id="element-2028" data-mp="2cl6ctxamo2m1" />
                    <span className="min-w-0 flex-1" data-id="element-2029" data-mp="27m3j3903litd">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2030" data-mp="2mbriu5sms9ez">
                        {todo.title} — {todo.pet.name}
                      </span>
                      <span className="block text-sm text-slate-500" data-id="element-2031" data-mp="2hdg8zv2c5ywr">{todo.detail}</span>
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2032" data-mp="1tox29jyxpu6s">
                      {todo.cta}
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2033" data-mp="1ym6qiwal7zt1" />
                    </span>
                  </Link>
                </li>)}
            </ul>}
        </section>

        <PetRules data-id="element-2034" data-mp="3a1luik17rrxn" />
        <VetConnect data-id="element-2035" data-mp="3a252b7x5gzxy" />
      </div>

      <FoundPetDialog open={foundOpen} onClose={() => setFoundOpen(false)} data-id="element-2036" data-mp="3a12ej8v4jdm9" />
    </main>;
}